import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/mohit/Documents/Github/cp4d-managed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The Essential Management Managed Services team is available to help with technical issues with the Cp4D managed cloud service, once the environment has been provisioned and a welcome letter sent IBM will assign a Cloud Service Coordinator (CSC) support team that will provide:`}</p>
    <ul>
      <li parentName="ul">{`single point of Client contact for incident and change management oversight.`}</li>
      <li parentName="ul">{`guide the client through the onboarding process and how to open a support ticket.`}</li>
      <li parentName="ul">{`management of maintenance intervals.`}</li>
      <li parentName="ul">{`monitoring of problem or failure events, tracking events to closure and root cause analysis for Severity 1 outages.`}</li>
      <li parentName="ul">{`monthly service level objective reporting; and`}</li>
      <li parentName="ul">{`monitoring and tracking trouble tickets to resolution.`}</li>
      <li parentName="ul">{`The CSC support team conducts operating service reviews through weekly status meetings with the Client to review incidents and change management.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      